export const SET_ZIPCODE = "integration/SET_ZIPCODE"
export const SET_ZIPCODE_ERROR = "integration/SET_ZIPCODE_ERROR"
export const SET_RECOMMENDATIONS = "integration/SET_RECOMMENDATIONS"
export const SET_CARD_IDENTIFIER = "integration/SET_CARD_IDENTIFIER"
export const SHOW_EMAIL_MODAL = "integration/SHOW_EMAIL_MODAL"
export const SET_CONFIGURED_EXPERIENCE = "integration/SET_CONFIGURED_EXPERIENCE"
export const SET_EMPLOYER = "integration/SET_EMPLOYER"
export const SET_MARKETPLACE_TOKEN = "integration/SET_MARKETPLACE_TOKEN"
export const SET_SPECIALIST = "integration/SET_SPECIALIST"
export const SET_DIAGNOSIS_CONCERN_SEARCH = "integration/SET_DIAGNOSIS_CONCERN_SEARCH"
export const SET_DIAGNOSIS_CONCERN_REC = "integration/SET_DIAGNOSIS_CONCERN_REC"
export const SET_INSURANCE_MESSAGES = "integration/SET_INSURANCE_MESSAGES"
export const SET_CONFIGURED_PLAN_PROVIDER = "integration/SET_CONFIGURED_PLAN_PROVIDER"
export const SET_DID_CAPTURE_LOCATION = "integration/SET_DID_CAPTURE_LOCATION"
export const SET_CAN_UPDATE_INSURANCE = "integration/SET_CAN_UPDATE_INSURANCE"



// WEBPACK FOOTER //
// ./assets/integration/actionTypes.js